import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { contentfulModels, components } from '@glowforge/ui-common';


import './glowforge-product-accordian.less';

const { getStringsForWidget, widgetPropType } = contentfulModels;
const { Markdown, SVG } = components;

const GlowforgeProductAccordian = (props) => {
  const strings = getStringsForWidget(props);
  const titleString = _.get(strings, 'glowforge-whats-included-title');
  const title = titleString && <h3 className='h3'>{titleString}</h3>;

  const accordian = _.reduce(props.sections, (output, section, key) => {
    output.push(
      <input
        type='checkbox'
        name='productAccordian'
        id={`row${key}`}
        key={`input${key}`} />,
    );
    output.push(
      <div className='row' key={`content${key}`}>
        <div className='title'>
          <label className='titleText' htmlFor={`row${key}`}>
            <SVG id='chevron-bold' />
            <span className='text'>{section.fields.title}</span>
          </label>
        </div>
        <Markdown className='content' source={section.fields.text} />
      </div>,
    );
    return output;
  }, []);


  return (
    <div className='GlowforgeProductAccordian greyFullWidth fullWidth'>
      <div className='section'>
        {title}
        <div className='accordian'>
          {accordian}
        </div>
      </div>
    </div>
  );
};

GlowforgeProductAccordian.propTypes = widgetPropType;

export default GlowforgeProductAccordian;



// WEBPACK FOOTER //
// ./app/components/product/glowforge-product-accordian.jsx